import React, { createContext, useContext } from 'react';

export type LayerSwitchDirection = 1 | -1 | 0;

export interface LayerSwitchContextValue {
  activeLayerId: string;
  layerSwitchDirection: LayerSwitchDirection;
  layerSwitchNonce: number;
  /** 直前のレイヤー切替の元レイヤー ID（スライド中のみ。値↔時間判定用） */
  layerSwitchFromLayerId: string | null;
}

const LayerSwitchContext = createContext<LayerSwitchContextValue>({
  activeLayerId: 'default',
  layerSwitchDirection: 0,
  layerSwitchNonce: 0,
  layerSwitchFromLayerId: null,
});

export const LayerSwitchProvider = LayerSwitchContext.Provider;

export function useLayerSwitch(): LayerSwitchContextValue {
  return useContext(LayerSwitchContext);
}
